import type { PortfolioDetailedReturns } from '../../hooks/usePortfolioDetailedReturns';

import { TableOverview } from '../TableOverview';
import { Transactions } from '../Transactions';
import { TABLE_OVERVIEW_COLUMN_LENGTH } from '../TableOverview/utils';
import { usePortfolioType } from '../../../HoldingsTable/hooks';
type Props = {
  portfolioDetailedReturns: PortfolioDetailedReturns;
};

export const PopulatedState = ({ portfolioDetailedReturns }: Props) => {
  const { holdings, liquidatedHoldings, currencyISO } =
    portfolioDetailedReturns;

  const portfolioType = usePortfolioType(portfolioDetailedReturns);

  return (
    <table
      aria-label="Returns Table"
      className="w-full border-separate border-spacing-0 bg-p-white-100"
    >
      <TableOverview portfolioDetailedReturns={portfolioDetailedReturns} />
      {holdings.map((holding) => (
        <Transactions
          key={holding.id}
          currencyISO={currencyISO}
          holding={holding}
          portfolioType={portfolioType}
        />
      ))}
      {liquidatedHoldings.map((holding) => (
        <Transactions
          key={holding.id}
          currencyISO={currencyISO}
          holding={holding}
          portfolioType={portfolioType}
        />
      ))}
      <tbody>
        <tr>
          <th
            colSpan={TABLE_OVERVIEW_COLUMN_LENGTH}
            className="h-x5 border-x-0 border-b border-t-0 border-solid border-soft"
          />
        </tr>
      </tbody>
    </table>
  );
};
